export enum OnboardingStep {
  Welcome = "welcome",
  ConvertMiles = "convert_miles",
  EarnRealYield = "earn_real_yield",
  EarnPP = "earn_pp",
  EarnPlume = "earn_plume",
}
